import { render } from "./PageSystem404.vue?vue&type=template&id=7e546216"
import script from "./PageSystem404.vue?vue&type=script&lang=js"
export * from "./PageSystem404.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__